module.exports = __webpack_public_path__ + "assets/img/4_1553.0e1cd3ee.jpg";